/*
 * Copyright © Manatee. 2026 All Rights Reserved.
 * Proprietary and confidential.
 */

import { Link as RouterLink, useLocation, type LinkProps } from "react-router";
import { cameFrom } from "../../lib/navigation";

/**
 * The console's internal link. Identical to react-router's Link, except that when the caller
 * passes no state it stamps the current location as `state.from`, so back affordances can return
 * to this page exactly as the user left it. Callers who pass state own it entirely.
 */
export function Link({ state, ...props }: LinkProps) {
  const location = useLocation();
  const stamped = state === undefined ? cameFrom(location) : state;
  return <RouterLink state={stamped} {...props} />;
}
